import { format } from 'date-fns';
import { shapeDate } from '@avangard/utils/data';
import { BaseEntity, Entity as DecribeEntity, Relation } from '@avangard/utils/entity';

import { getLocaleForDateFns } from '@lib/i18n';
import { UserEntity } from '@modules/user/entities';

import type { ChatMessage } from '@modules/types/graphql';

export type Entity = ChatMessage | null;

@DecribeEntity('ChatMessageEntity')
class ChatMessageEntity extends BaseEntity {
    id: string;
    message: string;
    viewed: boolean;
    createdAt: Date | null;
    updatedAt: Date | null;

    @Relation(() => UserEntity)
    sender: UserEntity;

    constructor(entity: Entity) {
        super(entity);

        this.id = entity?.id ?? '';
        this.message = entity?.message ?? '';
        this.viewed = entity?.viewed ?? false;

        this.createdAt = shapeDate(entity?.createdAt);
        this.updatedAt = shapeDate(entity?.updatedAt);
    }

    isSender(userId: string) {
        return userId === this.sender.id;
    }

    getSenderTitle() {
        const role = this.sender.getRole().toLowerCase();

        let result = this.sender.getFullNameByRole();

        if (this.sender.isStudent() || this.sender.isSchool()) {
            result = role + ' ' + this.sender.getFullNameByRole();
        }

        return result;
    }

    getCreatedAtTime() {
        const createdAt = this.createdAt ? new Date(this.createdAt) : null;
        const locale = getLocaleForDateFns();

        const time = createdAt ? format(createdAt, 'kk:mm', { locale }) : '//';

        return time;
    }
}

export { ChatMessageEntity };
